// extracted by mini-css-extract-plugin
module.exports = {"avatar":"profile-module--avatar--3xBz3","socialIcons":"profile-module--social-icons--myKKY"};